import { TurnaroundTime } from "node-library/dist/constants";

export const BLANK_SAMPLE_TEST_INFO = {
	selectedTests: [],
	expectationInputs: {},
	additionalTest: false,
	additionalTestDescription: "",
	turnaroundTime: TurnaroundTime.STANDARD,
};
